var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 9,
    viewBox: "0 0 16 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8326 7.85294C15.6095 8.06725 15.2477 8.06725 15.0245 7.85294L8 1.10679L0.975489 7.85294C0.752332 8.06725 0.390523 8.06725 0.167367 7.85294C-0.0557904 7.63862 -0.0557904 7.29115 0.167367 7.07684L7.19065 0.331863C7.29395 0.228153 7.41784 0.14532 7.55505 0.0882768C7.6955 0.0298801 7.84694 -0.0002506 8 -0.0002506C8.15306 -0.0002506 8.3045 0.0298801 8.44495 0.0882768C8.58216 0.14532 8.70605 0.228153 8.80935 0.331863L15.8326 7.07684C16.0558 7.29115 16.0558 7.63862 15.8326 7.85294Z",
    fill: "#133F26"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronUp);
export default __webpack_public_path__ + "static/media/chevron-up.b4db54193d2450345d033fadd5cd0935.svg";
export { ForwardRef as ReactComponent };